<template>
  <div id="contenedor-auditorias-listado-main">
    <v-card flat>
      <v-card-text>
        <template v-if="$apollo.queries.auditorias.loading">
          <v-skeleton-loader type="table-heading, table-thead, table-tbody"></v-skeleton-loader>
        </template>
        <template v-else>
          <template v-if="!$vuetify.breakpoint.mobile">
            <Desktop :auditorias="getAuditorias()" />
          </template>
          <template v-else>
            <Desktop :auditorias="getAuditorias()" />
            <!--
                <Mobile
                :auditorias="getAuditorias()"/>
                -->
          </template>
        </template>
      </v-card-text>
    </v-card>
    <v-dialog v-if="progresoDescarga" v-model="mostrarDescargando" width="200" persistent>
      <v-card>
        <v-card-title class="secondary--text">
          <v-row justify="center">
            Descargando
          </v-row>
        </v-card-title>
        <v-row class="pa-4" justify="center" align="center">
          <v-progress-circular
            :size="100"
            :width="15"
            :value="progresoDescarga"
            color="blue darken-1"
            dark
          >
            <h3>{{ progresoDescarga }}%</h3>
          </v-progress-circular>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import AUDITORIAS from '@/graphql/querys/administracion/auditorias/auditorias.gql';
import AUDITORIA_EXPEDIENTE from '@/graphql/querys/administracion/auditorias/auditoriaExpediente.gql';
import mixDescargarArchivo from '@/helpers/mixDescargarArchivo';
import eventBus from '@/helpers/eventBus';

import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'AuditoriasListadoMain',
  mixins: [mixDescargarArchivo],
  props: {
    filtros: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      estructuraZip: {},
      getSoloPublicKeys: [],
      mostrarDescargando: false,
      progresoDescarga: null,
    };
  },
  components: {
    Desktop,
    //    Mobile,
  },
  apollo: {
    auditorias: {
      query: AUDITORIAS,
    },
  },
  async mounted() {
    await this.$apollo.queries.auditorias.refetch();

    eventBus.$on('descargar-auditoria-expediente', async (auditoria) => {
      try {
        // Esperar a que la query se ejecute y obtenga los datos
        const { data } = await this.$apollo.query({
          query: AUDITORIA_EXPEDIENTE,
          variables: {
            id: auditoria.id,
          },
          fetchPolicy: 'network-only', // Asegura que siempre haga la consulta
        });
        this.datos = data.auditoriaExpediente;
        const expediente = {
          id: data.auditoriaExpediente.id,
          nombre: data.auditoriaExpediente.nombre,
          fileData: data.auditoriaExpediente.fileData
            ? JSON.parse(data.auditoriaExpediente.fileData)
            : null,
          informes: data.auditoriaExpediente.informes.map((informe) => ({
            id: informe.id,
            nombre: informe.nombre,
            fileData: informe.dataFile ? JSON.parse(informe.dataFile) : null,
            respuestas: informe.respuestas.map((respuesta) => ({
              id: respuesta.id,
              consecutivo: respuesta.consecutivo,
              numeroOficio: respuesta.numeroOficio,
              dataFile: respuesta.dataFile ? JSON.parse(respuesta.dataFile) : null,
              detalles: respuesta.detalles.map((detalle) => ({
                numeroObservacion: detalle.observacionDetalle.auditoriaObservacion.numero,
                desglose: detalle.observacionDetalle.texto,
                documentos: detalle.documentos.map((documento) => ({
                  id: documento.id,
                  nombre: documento.nombre,
                  fileData: documento.fileData ? JSON.parse(documento.fileData) : null,
                })),
              })),
            })),
            observaciones: informe.observaciones.map((observacion) => ({
              numero: observacion.numero,
              detalles: observacion.detalles.map((detalle) => ({
                texto: detalle.texto,
                espesificaciones: detalle.espesificaciones.map((especificacion) => ({
                  id: especificacion.id,
                  fileData: especificacion.fileData ? JSON.parse(especificacion.fileData) : null,
                })),
                seguimientos: detalle.seguimientos.map((seguimiento) => ({
                  id: seguimiento.id,
                  fileData: seguimiento.fileData ? JSON.parse(seguimiento.fileData) : null,
                })),
              })),
            })),
          })),
        };

        const addFileToZip = (fileData, carpeta, nombre) => {
          if (fileData && fileData.public_key) {
            this.getSoloPublicKeys.push(fileData.public_key);
            this.estructuraZip[fileData.public_key] = { carpeta, nombre };
          }
        };

        addFileToZip(expediente.fileData, '', 'OFICIO DE INICIO DE AUDITORIA');

        expediente.informes.forEach((informe) => {
          // si el informe tiene un archivo, lo agregamos al zip
          addFileToZip(
            informe.fileData,
            `Informes/${informe.nombre}`,
            informe.nombre,
          );
          (informe.observaciones || []).forEach((observacion) => {
            (observacion.detalles || []).forEach((detalle) => {
              // si los detalles de observaciones tienen especificaciones, los agregamos al zip
              (detalle.espesificaciones || []).forEach((especificacion) => {
                addFileToZip(
                  especificacion.fileData,
                  `Informes/${informe.nombre}/Especificaciones de Observaciones/${observacion.numero}/${detalle.texto}`,
                  especificacion.fileData?.name,
                );
              });
              // si los detalles de observaciones tienen seguimientos, los agregamos al zip
              (detalle.seguimientos || []).forEach((seguimiento) => {
                addFileToZip(
                  seguimiento.fileData,
                  `Informes/${informe.nombre}/Seguimientos/${observacion.numero}/${detalle.texto}`,
                  seguimiento.fileData?.name,
                );
              });
            });
          });
          // si el informe tiene respuestas, se buscan sus detalles y documentos
          // y se agregan al zip
          (informe.respuestas || []).forEach((respuesta) => {
            // si la respuesta tiene un archivo se agrega al zip
            addFileToZip(
              respuesta.fileData,
              `informes/${informe.nombre}/Respuestas/${respuesta.numeroOficio}`,
              `Respuesta ${respuesta.numeroOficio}`,
            );
            // se busca en los detalles los documentos y se agregan al zip
            (respuesta.detalles || []).forEach((detalle) => {
              (detalle.documentos || []).forEach((documento) => {
                addFileToZip(
                  documento.fileData,
                  `Informes/${informe.nombre}/Respuestas/Observaciones/${detalle.numeroObservacion}/${detalle.desglose}`,
                  documento.fileData?.name,
                );
              });
            });
          });
        });
        if (this.getSoloPublicKeys.length === 0) {
          this.mixMensajeError('No se encontraron documentos para descargar.');
          return;
        }
        this.mixExportarDocumentosPdf(expediente.nombre);
      } catch (error) {
        // console.error('Error al obtener el expediente:', error);
        this.mixMensajeError('Error al generar el expediente de la auditoría');
      }
    });
  },
  methods: {
    getAuditoriaExpediente() {
      if (!this.auditoriaExpediente) return {};
      return this.auditoriaExpediente;
    },
    getAuditorias() {
      if (!this.auditorias) return [];
      return this.auditorias
        .slice()
        .sort((a, b) => new Date(a.periodoDel) - new Date(b.periodoDel))
        .filter(({ ejercicio }) => ejercicio === this.filtros.ejercicio)
        .filter(({ idEnteFiscalizador }) => {
          const { enteFiscalizador } = this.filtros;
          if (!enteFiscalizador) return true;
          return enteFiscalizador === idEnteFiscalizador;
        })
        .filter((auditoria) => {
          if (!this.filtros.buscarTexto) return auditoria;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const nombre = this.$normalizacionTexto(auditoria.nombre);
          return expt.test(nombre);
        })
        .map((auditoria) => {
          let totalObservaciones = 0;
          let totalObservacionesPorSolventar = 0;
          auditoria.informes.forEach((informe) => {
            totalObservaciones += informe.observaciones.length;
            totalObservacionesPorSolventar += informe.observaciones.filter(
              (obs) => obs.estatus !== 'SOLVENTADA',
            ).length;
          });
          const colorPorSolventar = this.getColorPorSolventar(totalObservacionesPorSolventar);
          // Añadir los totales a la auditoría
          return {
            totalObservaciones,
            totalObservacionesPorSolventar,
            colorPorSolventar,
            ...auditoria,
          };
        });
    },
    getColorPorSolventar(total) {
      if (total > 0) return '#EF5350';
      return 'base5';
    },
  },
};
</script>
